module.exports = __webpack_public_path__ + "static/ice_coffee-942cfeb52dc87051a8e1d29c0f7e6e50.png";